module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.auth) ? _c('div', {
    staticClass: "questionnaire"
  }, [(_vm.allQuestionnaire && !(_vm.showMessage || _vm.error)) ? [(!!_vm.mainDescription) ? _c('h3', {
    staticClass: "questionnaire__description"
  }, [_vm._v(_vm._s(_vm.mainDescription))]) : _vm._e(), _c('Accordion', {
    attrs: {
      "list": _vm.formList
    },
    on: {
      "formId": _vm.questionList
    }
  }, [(_vm.isAnketaLoading) ? _c('Spinner', {
    staticClass: "questionnaire__spinner"
  }) : _vm._e(), (_vm.isAnswersList && !_vm.isAnketaLoading) ? _c('Result', {
    attrs: {
      "answers": _vm.answersList
    }
  }) : (!_vm.isAnswersList && _vm.isQuestions && !_vm.isAnketaLoading) ? _c('Anketa', {
    attrs: {
      "description": _vm.description,
      "questions": _vm.questions
    },
    on: {
      "submit": _vm.formSubmit
    }
  }) : _c('Messages', {
    attrs: {
      "size": "middle",
      "message": "Нет данных для анкеты",
      "error": true
    }
  })], 1)] : (_vm.showMessage || _vm.error) ? _c('Messages', {
    attrs: {
      "size": "middle",
      "message": _vm.messageText,
      "showClose": true,
      "error": _vm.error
    },
    on: {
      "closeMessage": _vm.closeMessage
    }
  }) : _c('Noitem', {
    attrs: {
      "text": _vm.noitemText
    }
  })], 2) : _c('ExtButton', {
    staticClass: "auth-btn",
    attrs: {
      "color": "default",
      "size": "small",
      "factor": 1.4,
      "wide": true,
      "fill": _vm.auth
    },
    on: {
      "click": _vm.authPopup
    }
  }, [_vm._v("Авторизация")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-289f9bb6","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/questionnaire/Questionnaire.vue
// module id = 76e595c1ac055f38e1a4
// module chunks = 5